import {
  SET_RECENTLY_BLOCKED,
  SET_RECENTLY_UNBLOCKED,
  SET_RECENTLY_DELETED
} from '@actions/types';
import { showSuccessMessage, showErrorMessage } from "@global";

import {
  getAPIRequest,
  postAPIRequest
} from '@actions';

export const blockUser = (user_id, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/block_user',
        { user_id : user_id },
        response => {
          dispatch({ type: SET_RECENTLY_BLOCKED, payload: user_id });
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const unblockUser = (user_id, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/unblock_user',
        { user_id : user_id },
        response => {
          dispatch({ type: SET_RECENTLY_UNBLOCKED, payload: user_id });
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const setRecentlyDeleted = (id) => {
  return (dispatch) => {
    dispatch({ type: SET_RECENTLY_DELETED, payload: id });
  };
};

export const deleteUser = (user_id, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/delete_user',
        { user_id : user_id },
        response => {
          onSuccess();
          dispatch(setRecentlyDeleted(user_id));
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const getEmailsForDownload = (onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      getAPIRequest(
        '/admin/get_emails_for_download',
        {},
        response => {
          onSuccess(response.users);
        }
      )
    );
  };
};
